export default "__VITE_ASSET__2bf0c923__"